export enum InsuranceFlowChannel {
  IN_APP = 'IN_APP',
  EXTERNAL = 'EXTERNAL',
  INSURER_PLATFORM = 'INSURER_PLATFORM',
  POSTAL = 'POSTAL',
}

export const getInsuranceFlowChannelLabel = (
  value: InsuranceFlowChannel | string
): string => {
  switch (value) {
    case InsuranceFlowChannel.IN_APP:
      return $localize`Plateforme LTY`;
    case InsuranceFlowChannel.EXTERNAL:
      return $localize`Hors plateforme`;
    case InsuranceFlowChannel.INSURER_PLATFORM:
      return $localize`Plateforme assureur`;
    case InsuranceFlowChannel.POSTAL:
      return $localize`Courrier`;
    default:
      return value;
  }
};
